export default "__VITE_ASSET__BYqUV4pW__"